import React, { useState } from 'react';
import { useQueryClient } from 'react-query';
import { useFilteringOptions } from '../../../../api/Category'
import Filtering from './Filtering';

function FilteringOptions({ categoryId }) {
  const queryClient = useQueryClient();
  const { isLoading, isError, data: filteringOptionsData } = useFilteringOptions(categoryId);
  const [selectedCategoryId, setSelectedCategoryId] = useState(null);
  
  if (isLoading) {
    return <div>Loading...</div>;
  }

  if (isError) {
    return <div>Error occurred while fetching main categories.</div>;
  }
  
  function handleSubCategoryClick(category) {
    console.log(category?.id)
    queryClient.setQueryData('selectedId', category?.id);
    queryClient.setQueryData('selectedName', category?.name);
    queryClient.setQueryData('selectedHidden', category.hidden);
    
    queryClient.setQueryData('selectedfilteringOptions', category?.name);
    queryClient.setQueryData('selectedfiltering', '');

    setSelectedCategoryId(category?.id);
  }
  return (
    <>
    <div className='categbox'>
      <p className='ctit'>필터링 옵션</p>
      <div type="필터링옵션" className='kwutOX'>
        <ul>
          {filteringOptionsData?.data !== undefined && filteringOptionsData?.data.map((category) => (
            <li className='fBSFej' key={category?.id}>
              <button 
                onClick={() => handleSubCategoryClick(category)}
                style={{ color: selectedCategoryId === category?.id ? '#0073e9' : 'rgb(0, 0, 0)' }}
                >{category?.name}</button>
            </li>
          ))}
        </ul>
      </div>
    </div>
    {selectedCategoryId && (
      <Filtering categoryId={selectedCategoryId} key={selectedCategoryId} />
    )}
    </>
  );
}

export default FilteringOptions;